import { useMediaQuery, Theme } from "@mui/material";

function useDimensions() {
  const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("sm"), {
    noSsr: true,
  });

  const isMedium = useMediaQuery<Theme>(
    theme => theme.breakpoints.between("sm", "md"),
    { noSsr: true }
  );

  const isLarge = useMediaQuery<Theme>(
    theme => theme.breakpoints.between("md", "lg"),
    { noSsr: true }
  );

  const isXLarge = useMediaQuery<Theme>(theme => theme.breakpoints.up("lg"), {
    noSsr: true,
  });

  return { isSmall, isMedium, isLarge, isXLarge };
}

export default useDimensions;
